import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, MAINTENANCE_ASPECT_TYPE, MaintenanceAspect, RefCode, setDefaultLocationFromUser } from 'assets-model';
import { MaintenanceAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class MaintenanceAspectItemComponentBase extends CrudItemComponent<MaintenanceAspect, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  maintenanceTypeSelectionList: RefCode[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected maintenanceAspectService: MaintenanceAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(MAINTENANCE_ASPECT_TYPE, fb, elementRef, router, route, userStorage, dialog, maintenanceAspectService, injector, snackbar);
  }

  createNewItem() {
    return new MaintenanceAspect();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      aspectAssetId: [null, []],
      lockVersion: [null, []],
      maintenanceType: [null, [requiredValidator,]],
      periodicMaintenance: [null, [requiredValidator,]],
      periodicMaintenanceDays: [null, []],
      routineMaintenance: [null, [requiredValidator,]],
      routineMaintenanceDays: [null, []],
      visualInspection: [null, [requiredValidator,]]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.aspectAssetId?.disable();
    }
  }
  
  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  maintenanceTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('MAINTENANCE_TYPE').subscribe(
      data => {
        this.maintenanceTypeSelectionList = data;
      }
    );
  }

  maintenanceTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  maintenanceTypeChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.maintenanceTypeChangedByUser(value, unsetDependents);
    }
  }  
  
  maintenanceTypeChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  periodicMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  periodicMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.periodicMaintenanceChangedByUser(value, unsetDependents);
    }
  }  
  
  periodicMaintenanceChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  
  periodicMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.periodicMaintenanceDaysChangedByUser(value, unsetDependents);
    }
  }  
  
  periodicMaintenanceDaysChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  routineMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  routineMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.routineMaintenanceChangedByUser(value, unsetDependents);
    }
  }  
  
  routineMaintenanceChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  
  routineMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.routineMaintenanceDaysChangedByUser(value, unsetDependents);
    }
  }  
  
  routineMaintenanceDaysChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  visualInspectionChanging(value: boolean, unsetDependents: boolean = true) {}
  
  visualInspectionChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.visualInspectionChangedByUser(value, unsetDependents);
    }
  }  
  
  visualInspectionChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get aspectAssetId() {
    return this.control('aspectAssetId');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get maintenanceType() {
    return this.control('maintenanceType');
  }
  
  get periodicMaintenance() {
    return this.control('periodicMaintenance');
  }
  
  get periodicMaintenanceDays() {
    return this.control('periodicMaintenanceDays');
  }
  
  get routineMaintenance() {
    return this.control('routineMaintenance');
  }
  
  get routineMaintenanceDays() {
    return this.control('routineMaintenanceDays');
  }
  
  get visualInspection() {
    return this.control('visualInspection');
  }
  
}





